<template>
  <div>
    <section class="Parent">
      <p @click="toggle" class="Question">{{ question }}</p>
      <template v-if="!isImage && !isList">
        <div v-if="show" class="Answer">
          <p
            class="padded-line"
            v-for="(line, idx) in answer.split('\n')"
            :key="idx"
          >
            {{ line }}
          </p>
        </div>
      </template>
      <template v-else-if="isList">
        <div v-if="show" class="Answer">
          <template v-for="(line, idx) in answer">
            <p class="ListHeader" v-if="!line.listItem" :key="idx">
              {{ line.value }}
            </p>
            <p class="ListItem" v-else :key="idx">
              <span>{{ line.value }}</span>
            </p>
          </template>
        </div>
      </template>
      <template v-else>
        <div v-if="show" class="Answer">
          <div class="image-answer" v-for="(line, idx) in answer" :key="idx">
            <img :src="require(`../../assets/faq/${line.href}`)" />
            <p>{{ line.value }}</p>
          </div>
        </div>
      </template>
      <div @click="toggle" class="Button">
        <div class="HLine" />
        <div v-show="!show" class="VLine" />
      </div>
    </section>
    <div class="Line" />
  </div>
</template>

<script>
import { sendAnalytics } from '../../shared/analytics';

export default {
  name: 'QandA',
  props: [
    'question',
    'answer',
    'isImage',
    'analyticsPermitted',
    'metaData',
    'isList',
  ],
  data() {
    return {
      show: false,
      sent: false,
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
      if (this.sent || !this.analyticsPermitted) {
        return;
      }

      sendAnalytics('tap_faq', {
        title: `${this.metaData}_${this.$i18n.locale}`,
      });
      this.sent = true;
    },
  },
};
</script>

<style scoped>
.Parent {
  display: grid;
  grid-template-columns: 1fr auto;
  --faq-spacing: 0.8em;
  --q-font-size: 70px;
  --faq-q-f-size: 20px;
  --faq-q-f-weight: 800;
  --faq-a-f-size: 20px;
  --faq-indent-p: 0 3em 0 3em;
  --h: 20px;
  --grid-row-min: 100px;
  grid-template-rows: minmax(var(--grid-row-min), auto) auto;
  align-items: center;
  padding: var(--faq-indent-p);
}
.Button {
  grid-column: 2;
  grid-row: 1;
  display: grid;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  cursor: pointer;
}
.Question {
  cursor: pointer;
  height: 70%;
  display: grid;
  align-items: center;
  grid-column: 1;
  grid-row: 1;
  font-size: var(--faq-q-f-size);
  font-weight: 800;
  max-width: 90%;
}
.Answer {
  cursor: text;
  grid-column: 1 / -1;
  grid-row: 2;
  font-weight: 400;
  font-size: var(--faq-a-f-size);
  max-width: 1200px;
  margin-bottom: 2em;
}

.Answer .padded-line {
  padding-top: 1em;
}
.HLine {
  grid-area: 1 / 1;
  width: var(--h);
  height: 2px;
  background: #2b4047;
}
.VLine {
  grid-area: 1 / 1;
  width: 2px;
  height: var(--h);
  justify-self: center;
  background: #2b4047;
}
.image-answer {
  display: flex;
  align-items: center;
}
.Line {
  width: 100%;
  height: 1px;
  background: #c8d1d3;
}
@media (max-width: 800px) {
  .Parent {
    --q-font-size: 60px;
    --grid-row-min: 88px;
    --faq-indent-p: 0 1.4em 0 1.4em;
    --h: 15px;
  }
}
@media (max-width: 600px) {
  .Parent {
    --q-font-size: 55px;
  }
}
@media (max-width: 550px) {
  .Parent {
    --q-font-size: 30px;
    --faq-a-f-size: 14px;
    --faq-q-f-size: 14px;
    --faq-indent-p: 0;
    --grid-row-min: 88px;
  }
  .symbolImage {
    width: 50px;
    height: 50px;
  }
}
.ListItem {
  font-weight: 400;
  font-size: var(--faq-a-f-size);
  max-width: 1200px;
}
.ListItem span {
  display: list-item;
  border-style: solid;
}
.ListHeader {
  margin-top: 30px;
  margin-bottom: 16px;
}
</style>
